module.exports = __webpack_public_path__ + "img/iso.fc143ac.svg";